export default __webpack_public_path__ + "static/media/mongoose_logo.df9141d3.png";